// src/style-comps/RolesPermissions.styles.js
import styled from "styled-components";

export const Container = styled.div`
  padding: 20px 28px;
  width: 100%;
  overflow-y: auto;
  font-family: "Roboto", sans-serif;
  color: #333;
`;

export const PageHeader = styled.div`
  margin-bottom: 24px;
`;

export const PageTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px 0;
`;

export const PageSubtitle = styled.p`
  font-size: 16px;
  color: #888;
  margin: 0;
  max-width: 560px;
  line-height: 1.5;
`;

// ── Role Tabs ──────────────────────────────────────────────
export const TabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 28px;
`;

export const RoleTab = styled.button`
  padding: 8px 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1.5px solid ${({ active }) => (active ? "#61cbc9" : "#d0d0d0")};
  background: ${({ active }) => (active ? "#61cbc9" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "#444")};
  transition: all 0.2s ease;

  &:hover {
    border-color: #61cbc9;
    background: ${({ active }) => (active ? "#4ab8b6" : "rgba(97,203,201,0.08)")};
  }
`;

export const AddRoleBtn = styled.button`
  padding: 8px 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1.5px dashed #c0c0c0;
  background: transparent;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #61cbc9;
    color: #61cbc9;
  }
`;

// ── Two-column layout ──────────────────────────────────────
export const PanelRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  gap: 0;
  align-items: start;
  min-height: 520px;
`;

export const Panel = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  padding: 20px;
  overflow: hidden;
`;

export const PanelTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RoleBadge = styled.span`
  display: inline-block;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  background: #61cbc9;
  color: #fff;
`;

// ── Search / Filter ────────────────────────────────────────
export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 14px;
  background: #fafafa;

  svg {
    color: #aaa;
    flex-shrink: 0;
  }

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 14px;
    color: #333;
    width: 100%;
    font-family: "Roboto", sans-serif;
  }
`;

// ── Accordion (category group) ─────────────────────────────
export const CategoryBlock = styled.div`
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  user-select: none;
  border-radius: 6px;
  transition: background 0.15s;

  &:hover {
    background: rgba(97, 203, 201, 0.06);
  }

  svg {
    color: #999;
    transition: transform 0.2s;
    transform: ${({ open }) => (open ? "rotate(90deg)" : "rotate(0deg)")};
  }
`;

export const CategoryItems = styled.div`
  overflow: hidden;
  max-height: ${({ open }) => (open ? "1000px" : "0")};
  transition: max-height 0.3s ease;
`;

export const PermissionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 6px 9px 14px;
  border-radius: 6px;
  transition: background 0.15s;

  &:hover {
    background: rgba(97, 203, 201, 0.06);
  }
`;

export const PermissionInfo = styled.div`
  flex: 1;
`;

export const PermissionName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #222;
`;

export const PermissionDesc = styled.div`
  font-size: 14px;
  color: #999;
  margin-top: 2px;
`;

export const AddIcon = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid #61cbc9;
  background: transparent;
  color: #61cbc9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
  transition: all 0.2s;

  &:hover {
    background: #61cbc9;
    color: #fff;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

// ── Transfer arrows ────────────────────────────────────────
export const ArrowCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding-top: 60px;
`;

export const ArrowBtn = styled.button`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: ${({ fwd }) => (fwd ? "#61cbc9" : "rgba(97,203,201,0.25)")};
  border: none;
  cursor: pointer;
  color: ${({ fwd }) => (fwd ? "#fff" : "#61cbc9")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.1);
    background: ${({ fwd }) => (fwd ? "#4ab8b6" : "rgba(97,203,201,0.45)")};
  }
`;

// ── Selected permission cards ──────────────────────────────
export const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 4px;
  }
`;

export const SelectedCard = styled.div`
  background: #fafafa;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  }
`;

export const SelectedCardInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SelectedCardName = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin-bottom: 3px;
`;

export const SelectedCardDesc = styled.div`
  font-size: 14px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Scope toggles (All / Own / None)
export const ScopeGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const ScopeBtn = styled.button`
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ active }) => (active ? "#61cbc9" : "#ddd")};
  background: ${({ active }) => (active ? "#61cbc9" : "transparent")};
  color: ${({ active }) => (active ? "#fff" : "#888")};
  cursor: pointer;
  transition: all 0.15s;

 &:hover {
    border-color: #61cbc9;
    background: ${({ active }) => (active ? "#4ab8b6" : "transparent")};
    color: ${({ active }) => (active ? "#fff" : "#61cbc9")};
}
`;

export const DeleteIconBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #bbb;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    color: #e05c5c;
    background: rgba(224, 92, 92, 0.08);
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #bbb;
  font-size: 14px;
`;

export const AvailableScroll = styled.div`
  max-height: 480px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 4px;
  }
`;


// ── Role Tab wrapper (hover shows edit/delete icons) ──────
export const RoleTabWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  white-space: nowrap;

  &:hover .role-tab-actions {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

// ── Tab icon button (edit / delete) ───────────────────────
export const TabIconBtn = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #aaa;
  border-radius: 4px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  transition: color 0.15s;

  &:hover {
    color: ${({ danger }) => (danger ? "#e05c5c" : "#61cbc9")};
  }
`;

// ── Add All button ─────────────────────────────────────────
export const AddAllBtn = styled.button`
  padding: 5px 12px;
  border-radius: 6px;
  border: none;
  background: #61cbc9;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #4ab8b6;
  }
`;

// ── Discard / Save buttons ─────────────────────────────────
export const DiscardBtn = styled.button`
  padding: 5px 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #aaa;
    color: #333;
  }
`;

export const SaveBtn = styled.button`
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  background: #61cbc9;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #4ab8b6;
  }
`;

export const SaveSuccessText = styled.span`
  font-size: 14px;
  color: #61cbc9;
  font-weight: 600;
`;

// ── Error Banner ───────────────────────────────────────────
export const ErrorBanner = styled.div`
  color: crimson;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 14px;
`;

// ── Modal Overlay + Box ────────────────────────────────────
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalBox = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 28px;
  width: ${({ width }) => width ?? "420px"};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  font-family: "Roboto", sans-serif;
`;

export const ModalTitle = styled.h3`
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: ${({ center }) => (center ? "center" : "left")};
`;

export const ModalSubtitle = styled.p`
  margin: 0 0 20px;
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  text-align: ${({ center }) => (center ? "center" : "left")};
`;

export const ModalEmoji = styled.div`
  font-size: 36px;
  text-align: center;
  margin-bottom: 12px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: ${({ center }) => (center ? "center" : "flex-end")};
  align-items: center;
  gap: 10px;
  width: 100%;
  position: relative;
  z-index: 2;

  button {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    pointer-events: auto !important;
  }
`;

export const ModalCancelBtn = styled.button`
  min-width: 80px;
  height: 36px;
  padding: 8px 18px;
  border-radius: 8px;
  border: 1px solid #ccc !important;
  background: #fff !important;
  color: #666 !important;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  z-index: 3;

  &:hover,
  &:focus,
  &:active {
    display: inline-flex !important;
    background: #f7f7f7 !important;
    border-color: #aaa !important;
    color: #333 !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
  }
`;

export const ModalConfirmBtn = styled.button`
  min-width: ${({ danger }) => (danger ? "90px" : "120px")};
  height: 36px;
  padding: 8px 18px;
  border-radius: 8px;
  border: none !important;
  background: ${({ danger }) => (danger ? "#e05c5c" : "#61cbc9")} !important;
  color: #fff !important;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: ${({ danger }) => (danger ? 700 : 600)};
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  z-index: 3;

  &:disabled {
    opacity: 0.7 !important;
    cursor: not-allowed;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled),
  &:active:not(:disabled) {
    display: inline-flex !important;
    opacity: 0.88 !important;
    visibility: visible !important;
    transform: none !important;
  }
`;

// ── Form field ─────────────────────────────────────────────
export const FieldGroup = styled.div`
  margin-bottom: ${({ last }) => (last ? "20px" : "14px")};
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #444;
  display: block;
  margin-bottom: 6px;
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  transition: border-color 0.2s;

  &:focus {
    border-color: #61cbc9;
  }
`;

export const FieldTextarea = styled.textarea`
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  transition: border-color 0.2s;

  &:focus {
    border-color: #61cbc9;
  }
`;

export const FieldError = styled.p`
  color: crimson;
  font-size: 13px;
  margin: 0 0 12px;
`;